import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anon = process.env.REACT_APP_SUPABASE_ANON_KEY;

/**
 * Supabase client used only for OAuth flows (Google/Microsoft sign-in).
 * Regular email/password auth still routes through our FastAPI shims so
 * cookies are set server-side. After an OAuth redirect, the callback
 * page uses this client to read the session, then POSTs the access token
 * to `/api/auth/oauth-sync` so the backend can mirror the profile row
 * and set the sb-* cookies.
 */
const supabase = createClient(url, anon, {
  auth: {
    // Use sessionStorage — the sync-to-backend endpoint sets the httpOnly
    // cookies that are the source of truth from then on.
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: "pkce",
  },
});

export default supabase;
